// extracted by mini-css-extract-plugin
export default {"title":"styles_title__4HpID","secondaryTitle":"styles_secondaryTitle__Jdxf8","backBtnRow":"styles_backBtnRow__9hpz0","backButton":"styles_backButton__cUu0h"};